import { ObjectOptions, TSchema, Type } from '@sinclair/typebox';

export const ListResponseSchema = <DataEntry extends TSchema>(data: DataEntry, opts?: ObjectOptions) =>
  Type.Object(
    {
      data: Type.Array(data),
      total_count: Type.Optional(Type.Number({ description: 'Total number of results if supported by the provider.' })),
      next_cursor: Type.Optional(
        Type.String({ description: 'Cursor to get the next page of results if supported. Else use `offset`.' }),
      ),
    },
    opts,
  );
